import Usuario from "model/administracao/cadastro/Usuario";

export default class RespostaSolicitacao {
    idSolicitacao: number;
    resposta: string;
    observacaoResposta: string | null;
    responsavelAprovacao: Usuario | null;
    prazoAprovacao: Date | null;
    responsavelRevisao: Usuario | null;
    prazoRevisao: Date | null;

    constructor(
        idSolicitacao: number = 0,
        resposta: string = '',
        observacaoResposta: string | null = null,
        responsavelAprovacao: Usuario | null = null,
        prazoAprovacao: Date | null = new Date(),
        responsavelRevisao: Usuario | null = null,
        prazoRevisao: Date | null = new Date()
    ) {
        this.idSolicitacao = idSolicitacao;
        this.resposta = resposta;
        this.observacaoResposta = observacaoResposta;
        this.responsavelAprovacao = responsavelAprovacao;
        this.prazoAprovacao = prazoAprovacao;
        this.responsavelRevisao = responsavelRevisao;
        this.prazoRevisao = prazoRevisao;
    }
}